/**
 * Player Constants
 *
 * Centralized constants for the media player.
 * Keep all magic numbers and configuration values here for easy maintenance.
 */

/**
 * Skip interval in seconds for forward/backward buttons
 */
export const SKIP_INTERVAL_SECONDS = 30;

/**
 * Keyboard seek step in seconds (arrow keys)
 */
export const KEYBOARD_SEEK_STEP_SECONDS = 5;

/**
 * Available playback speed options
 * More evenly distributed across the range for better UX
 */
export const PLAYBACK_SPEED_OPTIONS = [0.7, 1.0, 1.2, 1.5, 1.7, 2.0];

/**
 * Animation durations (in milliseconds)
 */
export const ANIMATION = {
	HOVER_TRANSITION: 200,
	SCALE_TRANSITION: 150,
	SHIMMER_DURATION: 1500,
} as const;
